import { useFormik } from "formik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// observable store
const jobFilterStore = makeObservable({});
const jobNavigationStore = createSearchResultNavigationStore();
const useJobFilters = () => {
  const formik = useFormik({
    initialValues: {
      limit: 50,
      offset: 0,
      tab: "instance",
      sort1: { operator: "ASC" },
      sort2: { operator: "ASC" },
      sort3: { operator: "ASC" },
      pickupId: { operator: "in" },
    },
  });

  const filterKeys = ["tab"];

  const skipKeys = ["limit", "offset"];

  useEffect(() => {
    // convert formik values to filter and update store
    jobFilterStore.set(
      convertToFilter({ values: formik.values, filterKeys, skipKeys }),
    );
  }, [formik.values]);

  return {
    formik,
  };
};

export { jobFilterStore, jobNavigationStore, useJobFilters };
